import React, { forwardRef, useMemo } from 'react'

import {
  ControllerFieldState,
  ControllerRenderProps,
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
  UseFormStateReturn,
} from 'react-hook-form'

import { UserDetailsProps } from '../../types'
import { getFieldType } from '../../utils'
import { parseComponentConfig } from '../../utils/parseComponentConfig'
import { IOcField, IOcFieldError } from '../../utils/types'
import { formComponentMap } from './formComponentMap'

interface Props {
  formControllerRenderProps: {
    field: ControllerRenderProps<FieldValues, string>
    fieldState: ControllerFieldState
    formState: UseFormStateReturn<FieldValues>
  }
  formValidationError:
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<any>>
    | undefined
  ocFieldError?: IOcFieldError
  ocField: IOcField
  userDetails: UserDetailsProps
  state: any
}

const FormComponent: React.FC<Props> = forwardRef((props, ref) => {
  const {
    formControllerRenderProps: { field },
    formValidationError,
    ocFieldError,
    ocField,
    userDetails,
    state,
  } = props

  // TODO: Error message

  const componentConfig =
    formComponentMap[getFieldType(ocField.type, ocField.code)]

  const { Component, componentProps } = useMemo(
    () =>
      parseComponentConfig({
        config: componentConfig,
        field,
        ocField,
      }),
    [field, componentConfig]
  )

  if (!componentConfig) {
    return null
  }

  return (
    <Component
      {...componentProps}
      value={field.value}
      ref={ref}
      userDetails={userDetails}
      state={state}
      errorMessage={ocFieldError?.message ?? formValidationError?.message}
    />
  )
})

export default FormComponent
